import type { Xinglet } from '@xing-com/crate-xinglet';

import { StartPageLoggedOut } from './startpage-logged-out';

export default class Entry implements Xinglet {
  public getComponent() {
    return (): JSX.Element => <StartPageLoggedOut />;
  }
}
